// @flow
import React, { useRef } from 'react';
import { Grid } from 'semantic-ui-react';
import { CommitMetricNameDropdownContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/metrics-level-configuration/CommitMetricNameDropdownContainer';
import { CommitMetricNameDeleteButtonContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/metrics-level-configuration/CommitMetricNameDeleteButtonContainer';
import { CommitMetricNameAddButtonContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/metrics-level-configuration/CommitMetricNameAddButtonContainer';
import { CommitMetricsDimensionsListContainer } from '@streaming-projects/user-commit-details/commit-custom-discounts/metrics-level-configuration/CommitMetricsDimensionsListContainer';

export const CommitMetricsLevelDiscountsMetricConfigurationItem = ({ readOnlyMode }) => {
  const metricDimensionRefs = useRef({
    dimensionArrayHelpers: null,
    dimensionColumnsConfiguration: null,
  });

  return (
    <>
      <Grid.Row>
        <Grid.Column width={3}>
          <CommitMetricNameDropdownContainer />
        </Grid.Column>
        <Grid.Column width={1}>
          <CommitMetricNameDeleteButtonContainer />
        </Grid.Column>
        <Grid.Column
          style={{
            marginLeft: '-2rem',
          }}
          width={1}
        >
          <CommitMetricNameAddButtonContainer metricDimensionRefs={metricDimensionRefs} />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column>
          <CommitMetricsDimensionsListContainer
            metricDimensionRefs={metricDimensionRefs}
            readOnlyMode={readOnlyMode}
          />
        </Grid.Column>
      </Grid.Row>
    </>
  );
};
